export default "__VITE_ASSET__aa49dd1c__"